<ng-container [formGroup]="form()">
  <ion-grid>
    <ion-row>
      <ion-col size="12">
        <ion-input
          formControlName="date"
          type="datetime-local"
          label="Fecha"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          [helperText]="dateHelperText()"
          [errorText]="getErrorMessage('date') | translate"
        ></ion-input>
      </ion-col>
    </ion-row>
    <ion-row class="ion-margin-bottom">
      <ion-col
        size="12"
        class="ion-text-wrap"
      >
        <ion-button
          size="small"
          (click)="openAddressbookModal()"
          [disabled]="isFormDisabled()"
        >
          <ion-icon
            aria-hidden="true"
            slot="start"
            src="../assets/material-symbols/search_24dp.svg"
          ></ion-icon>
          Buscar dirección
        </ion-button>

        @if (previousAddressData(); as prev) {
          @let isComplete = !!prev.companyName.trim() && !!prev.street.trim() && !!prev.location?.postalCode?.trim();
          @let isCopyDisabled = isFormDisabled() || !isComplete;
          <ion-button
            size="small"
            fill="outline"
            (click)="copyPreviousAddress()"
            [disabled]="isCopyDisabled"
            [title]="!isComplete ? 'El tramo anterior aún no tiene la dirección completa (empresa, calle y C.P.)' : ''"
          >
            <ion-icon
              slot="start"
              src="../assets/material-symbols/content_copy_24dp.svg"
            ></ion-icon>
            Copiar dirección anterior
          </ion-button>
        }
      </ion-col>

      <ion-col size="12">
        <ion-item
          lines="none"
          style="--background: var(--ion-color-light)"
        >
          @let location = locationSignal();
          <ion-label class="ion-text-wrap">
            @if (location && location.postalCode) {
              <p>
                ({{ location.postalCode }}) {{ location.city }},
                {{ 'states.' + location.countryCode + location.stateCode | translate }},
                {{ 'countries.' + location.countryCode | translate }}
              </p>
            } @else {
              <ion-button
                size="small"
                fill="outline"
                (click)="openPostalCodeModal()"
                [disabled]="isFormDisabled()"
              >
                <ion-icon
                  aria-hidden="true"
                  slot="start"
                  src="../assets/material-symbols/pin_drop_24dp.svg"
                ></ion-icon>
                Buscar ciudad / C.P.
              </ion-button>
            }
            @if (!location?.postalCode && form().touched) {
              <p><ion-text color="danger"> Error. Debe una ciudad / código postal. </ion-text></p>
            }
          </ion-label>
          @if (location) {
            <ion-button
              slot="end"
              fill="outline"
              (click)="openPostalCodeModal()"
              [disabled]="isFormDisabled()"
            >
              <ion-icon
                slot="icon-only"
                src="../assets/material-symbols/edit_24dp.svg"
              ></ion-icon>
            </ion-button>
          }
        </ion-item>
      </ion-col>

      <ion-col size="12">
        <ion-input
          label="Nombre / Empresa"
          formControlName="companyName"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          errorText="El nombre para identificar el lugar o al remitente/destinatario es obligatorio"
        ></ion-input>
      </ion-col>
      <ion-col size="12">
        <ion-input
          label="Calle, número"
          formControlName="street"
          labelPlacement="floating"
          fill="outline"
          mode="md"
          type="text"
          errorText="La dirección es obligatoria"
        ></ion-input>
      </ion-col>
    </ion-row>
  </ion-grid>
</ng-container>
